<div class="image-container">
  <ng-container *ngIf="imageUrl; else placeholder">
    <img [src]="imageUrl" alt="Preview" />
  </ng-container>

  <ng-template #placeholder>
    <div class="placeholder">
      <ion-icon name="image-outline"></ion-icon>
    </div>
  </ng-template>
</div>
